/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p[_ngcontent-%COMP%]{margin:0}hr[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0}.mat-card[_ngcontent-%COMP%]{padding:0}\n/*# sourceMappingURL=demand-trend-analysis-availability.component.css.map*/"];
export { styles as styles };
